import * as React from 'react'

const SvgDevicesIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.25 18.75H2.5c-.69 0-1.25-.56-1.25-1.25V10c0-.69.56-1.25 1.25-1.25h3.75c.69 0 1.25.56 1.25 1.25v7.5c0 .69-.56 1.25-1.25 1.25zM2.5 10v7.5h3.75V10H2.5zm15-7.5H3.75c-.69 0-1.25.56-1.25 1.25V7.5h1.25V3.75H17.5v8.75H8.75v1.25H10v2.5H8.75v1.25h5.625v-1.25H11.25v-2.5h6.25c.69 0 1.25-.56 1.25-1.25V3.75c0-.69-.56-1.25-1.25-1.25z"
      fill="#163250"
    />
  </svg>
)

export default SvgDevicesIcon
